import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ custom, palette }: Theme) => ({
  root: {
    maxWidth: 600,
    marginBottom: 15,
  },
  rootNoSpacing: {
    marginTop: -22,
  },
  badgeCombined: {
    backgroundColor: custom.status.success.light,
  },
  badgeCheck: {
    color: custom.green[1],
    height: 20,
  },
  badgeWithBorder: {
    border: `1px solid ${custom.grey[11]}`,
    padding: '7px 5px',
  },

  separator: {
    width: '100%',
    color: custom.grey[3],
    fontSize: 12,
    lineHeight: '20px',
    margin: '4px 3px',
  },
  popperAnchor: {
    width: '100%',
    marginLeft: -9,
    paddingLeft: 9,
    display: 'flex',
    flexWrap: 'wrap',
  },
  expand: {
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    padding: '6px 10px',
    fontSize: 14,
    color: palette.primary.main,
  },
  expandIcon: {
    marginTop: 4,
    marginLeft: 2,
    fontSize: 16,
  },
  versionsListHeader: {
    fontSize: 12,
    color: custom.grey[2],
    fontWeight: 'bold',
    lineHeight: '20px',
    padding: '8px 10px',
  },
  green: {
    color: custom.green[2],
  },
  option: {
    padding: '6px 10px',
    borderRadius: 5,
    cursor: 'pointer',
  },
  tooltip: {},
}));
